// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { FileText as RawFileText } from "lucide-react";
export const FileText = /* @__PURE__ */ createIcon(RawFileText, "FileText", 2);
